import React, { useState, useEffect } from "react";
import {
  IoHomeOutline,
  IoChevronDown,
  IoChevronUp,
  IoMenu,
  IoClose,
  IoPersonCircleOutline,
} from "react-icons/io5";
import { TbUserCancel } from "react-icons/tb";
import {
  FaCog,
  FaTruck,
  FaBox,
  FaWrench,
  FaShoppingCart,
  FaWarehouse,
  FaChartLine,
  FaMoneyBill,
  FaBook,
} from "react-icons/fa";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setSideCollapes,
  setPhoneToggle,
} from "../../redux/features/slices/modeSlice";
import { TbReportSearch } from "react-icons/tb";
import { useGetUserProfileQuery } from "../../redux/features/apiSlices/userApiSlice";
import { setUserProfile } from "../../redux/features/slices/user";
import { useGetCompanyQuery } from "../../redux/features/apiSlices/setup/company";
import { setCompany } from "../../redux/features/slices/setup";
import { Drawer } from "antd";

import { CiSettings, CiShop } from "react-icons/ci";
import { AiOutlineProduct } from "react-icons/ai";
import {
  HiOutlineWrenchScrewdriver,
  HiOutlineHomeModern,
} from "react-icons/hi2";
import { PiWarehouseLight } from "react-icons/pi";
import {
  MdOutlinePayments,
  MdOutlineAccountBalance,
  MdOutlineSell,
} from "react-icons/md";

// Link arrays
const links = [
  { id: 1, text: "Dashboard", icon: <IoHomeOutline size={20} />, path: "/" },
  {
    id: 2,
    text: "sale invoice",
    icon: <TbUserCancel size={20} />,
    path: "/pos",
  },
  {
    id: 3,
    text: "sale invoice view",
    icon: <TbUserCancel size={20} />,
    path: "/sale-invoice-view",
  },
  {
    id: 4,
    text: "Sale Return",
    icon: <TbUserCancel size={20} />,
    path: "/sale-return",
  },
  {
    id: 8,
    text: "sale return view",
    icon: <TbUserCancel size={20} />,
    path: "/sale-return-view",
  },
  {
    id: 5,
    text: "quotation",
    icon: <TbUserCancel size={20} />,
    path: "/quotation",
  },
  {
    id: 6,
    text: "quotation view",
    icon: <TbUserCancel size={20} />,
    path: "/quotation-view",
  },
  // {
  //   id: 7,
  //   text: "Pending FBR Invoices",
  //   icon: <TbUserCancel size={20} />,
  //   path: "/pending-fbr-invoices",
  // },
];

const settings = [
  { id: 1, text: "Users", path: "/users" },
  { id: 2, text: "Register", path: "/register" },
  { id: 3, text: "role & permissions", path: "/role-permission" },
  { id: 4, text: "Company Setup", path: "/company-setup" },
  { id: 4, text: "company view", path: "/company-view" },
  { id: 5, text: "payment method", path: "/payment-method" },
  { id: 6, text: "payment view", path: "/payment-view" },
  { id: 7, text: "barcode generator", path: "/barcode-generator" },
  { id: 8, text: "product viewer", path: "/product-viewer" },
];

const reports = [
  { id: 1, text: "load sheet", path: "/loadsheet" },
  { id: 2, text: "sale & purchase", path: "/sale-n-purchase" },
  { id: 3, text: "stock ledger", path: "/stockledger" },
  { id: 4, text: "customer report", path: "/customerreport" },
  { id: 5, text: "item list", path: "/itemlist" },
  { id: 6, text: "last purchase / sale", path: "/last-purchase-sale" },
  { id: 7, text: "daily stock", path: "/daily-stock" },
  { id: 8, text: "product wise sale", path: "/product-wise-sale" },
  { id: 9, text: "stock position", path: "/stock-position" },
  { id: 10, text: "gross profit", path: "/gross-profit-report" },
  { id: 11, text: "all sale invoices", path: "/all-sale-invoices" },
  { id: 12, text: "yearly expenses", path: "/yearly-expenses" },
  { id: 13, text: "max sale product", path: "/max-sale-product" },
  { id: 14, text: "unsold products", path: "/unsold-products" },
  { id: 15, text: "daily sales", path: "/daily-sales" },
  { id: 16, text: "aging receivable", path: "/aging-receiveable" },
  { id: 17, text: "aging payable", path: "/aging-payable" },
  { id: 18, text: "account ledger", path: "/account-ledger" },
  { id: 19, text: "outstanding report", path: "/outstanding-report" },
  { id: 20, text: "PDC Report", path: "/pdc-report" },
  { id: 21, text: "daily Trans Report", path: "/transaction-report" },
  { id: 22, text: "Trial Balance", path: "/trial-balance" },
  { id: 23, text: "Stock Ledger Summary", path: "/stock-ledger-summary" },
];

export const productGroups = [
  {
    id: "product_type",
    title: "Product Type",
    links: [
      { id: 1, text: "Product Type", path: "/product-type" },
      { id: 2, text: "Product Type View", path: "/producttype-view" },
    ],
  },
  {
    id: "brand",
    title: "Brand",
    links: [
      { id: 3, text: "Brand", path: "/add-brand" },
      { id: 4, text: "Brand View", path: "/brand-view" },
    ],
  },
  {
    id: "category",
    title: "Category",
    links: [
      { id: 5, text: "category", path: "/add-category" },
      { id: 6, text: "Category View", path: "/category-view" },
    ],
  },
  {
    id: "sub_category",
    title: "Sub Category",
    links: [
      { id: 7, text: "sub category", path: "/add-subcategory" },
      { id: 8, text: "Sub Category View", path: "/subcategory-view" },
    ],
  },
  {
    id: "unit",
    title: "Unit",
    links: [
      { id: 9, text: "unit", path: "/add-unit" },
      { id: 10, text: "Unit View", path: "/unit-view" },
    ],
  },
  {
    id: "packtype",
    title: "Pack Type",
    links: [
      { id: 11, text: "pack type", path: "/packtype" },
      { id: 12, text: "Pack Type View", path: "/packtype-view" },
    ],
  },
  {
    id: "product_items",
    title: "Products",
    links: [
      { id: 13, text: "new product", path: "/add-product" },
      { id: 14, text: "product", path: "/product" },
    ],
  },
];

const productLinks = productGroups.flatMap((g) => g.links);

// Setup sub-groups
export const setupGroups = [
  {
    id: "customer",
    title: "Customer",
    links: [
      { id: 1, text: "Customers", path: "/customers" },
      { id: 2, text: "Customers View", path: "/customers-view" },
      { id: 3, text: "Customer Category", path: "/add-customer-category" },
      {
        id: 4,
        text: "Customer Category View",
        path: "/customer-view-category",
      },
    ],
  },
  {
    id: "vendor",
    title: "Vendor",
    links: [
      { id: 5, text: "Vendor", path: "/vendor" },
      { id: 6, text: "Vendor View", path: "/vendor-view" },
    ],
  },
  {
    id: "warehouse",
    title: "Warehouse",
    links: [
      { id: 7, text: "Warehouse", path: "/warehouse" },
      { id: 8, text: "Warehouse View", path: "/warehouse-view" },
    ],
  },
  {
    id: "town",
    title: "Town",
    links: [
      { id: 9, text: "Add Town", path: "/add-town" },
      { id: 10, text: "Town View", path: "/town-view" },
    ],
  },
  {
    id: "saleman",
    title: "Salesman",
    links: [
      { id: 11, text: "Add Saleman", path: "/add-saleman" },
      { id: 12, text: "Saleman View", path: "/saleman-view" },
    ],
  },
  {
    id: "patty",
    title: "Patty Category",
    links: [
      { id: 13, text: "Add Patty Category", path: "/add-patty-category" },
      { id: 14, text: "Patty Category View", path: "/patty-category-view" },
    ],
  },
  {
    id: "gst",
    title: "GST Type",
    links: [
      { id: 15, text: "GST Type", path: "/gst-type" },
      { id: 16, text: "GST Type View", path: "/gst-type-view" },
    ],
  },
  {
    id: "schedule",
    title: "Schedule Type",
    links: [
      { id: 17, text: "Schedule Type", path: "/schedule-type" },
      { id: 18, text: "Schedule Type View", path: "/schedule-type-view" },
    ],
  },
  {
    id: "advancetax",
    title: "Advance Tax",
    links: [
      { id: 18, text: "Advance Tax", path: "/advance-tax" },
      { id: 19, text: "Advance Tax View", path: "/advance-tax-view" },
    ],
  },
  {
    id: "device",
    title: "Device",
    links: [
      { id: 20, text: "Add Device", path: "/add-device" },
      { id: 21, text: "Device View", path: "/device-view" },
    ],
  },
  {
    id: "role-permission",
    title: "User Roles & Permissions",
    links: [
      { id: 22, text: "Role & Permission View", path: "/role-permission-view" },
    ],
  },
];

const setupLinks = setupGroups.flatMap((g) => g.links);

const purchaseLinks = [
  { id: 1, text: "Purchase Order", path: "/purchase-order" },
  { id: 2, text: "Add Purchase", path: "/add-purchase" },
  { id: 3, text: "Purchase Invoice", path: "/purchase-invoice" },
  { id: 4, text: "Purchase Return", path: "/purchase-return" },
  { id: 5, text: "Purchase Return View", path: "/purchase-return-view" },
  { id: 6, text: "Purchase Orders View", path: "/purchase-orders-view" },
  { id: 7, text: "Purchase Invoice View", path: "/purchase-invoice-view" },
];

const inventoryLinks = [{ id: 1, text: "Inventory", path: "/get-inventory" }];

const stockLinks = [
  { id: 1, text: "Stock Value", path: "/stockvalue" },
  { id: 2, text: "Stock Adjustment", path: "/stockadjustment" },
];

const paymentsLink = [
  { id: 1, text: "Purchase Payments", path: "/payment-voucher" },
  { id: 2, text: "Receive Payment", path: "/recieve-voucher" },
  { id: 3, text: "Journal Payment", path: "/journal-payment" },
  { id: 4, text: "Journal Payment View", path: "/journal-payment-view" },
  { id: 5, text: "Patty Payment", path: "/patty-payment" },
  { id: 6, text: "Patty Payment View", path: "/patty-payment-view" },
  { id: 7, text: "Receive Payment View", path: "/receive-payment-view" },
  { id: 8, text: "Purchase Payment View", path: "/purchase-payment-view" },
];

const accounts = [
  { id: 1, text: "Chart of Accounts", path: "/chart-of-accounts" },
];

const hrLinks = [
  { id: 0, text: "HR Dashboard", path: "/hr-dashboard" },
  { id: 1, text: "Departments", path: "/hr-departments" },
  { id: 2, text: "Designations", path: "/hr-designations" },
  { id: 3, text: "Policies", path: "/hr-policies" },
  { id: 4, text: "Shifts", path: "/hr-shifts" },
  { id: 5, text: "Employees", path: "/hr-employees" },
  { id: 6, text: "Leaves", path: "/hr-leaves" },
  { id: 7, text: "Holidays", path: "/hr-holidays" },
  { id: 8, text: "Attendance Log", path: "/hr-attendance" },
  { id: 9, text: "Check IN/OUT Report", path: "/hr-checkinout-report" },
  { id: 10, text: "Manage Payroll", path: "/hr-payroll" },
  { id: 11, text: "Self Punch Kiosk", path: "/hr-punch" },
  { id: 12, text: "Attendance Tracker", path: "/hr-attendance-calendar" },
  { id: 13, text: "Calendar", path: "/hr-calendar" },
  { id: 14, text: "Asset Management", path: "/hr-assets" },
  { id: 15, text: "Appraisals", path: "/hr-appraisals" },
  { id: 16, text: "Recruitment", path: "/hr-recruitment" },
  // LOYALTY POINTS & BIOMETRIC DEVICE IMPLEMENTATION START
  { id: 17, text: "Biometric Devices", path: "/hr-biometric-devices" },
  // LOYALTY POINTS & BIOMETRIC DEVICE IMPLEMENTATION END
];

// Export sections at the top level
export const sections = {
  main: links,
  settings: settings,
  products: productLinks,
  reports: reports,
  setup: setupLinks,
  purchase: purchaseLinks,
  inventory: inventoryLinks,
  stock: stockLinks,
  payments: paymentsLink,
  accounts: accounts,
  hr: hrLinks,
};

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // Mobile toggle
  const { sideBarCollapes } = useSelector((state) => state.mode);
  const { user: userProfile } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);

  const { data: user, isLoading, error } = useGetUserProfileQuery();
  const { data: company } = useGetCompanyQuery();

  useEffect(() => {
    if (user) {
      dispatch(setUserProfile(user));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (company) {
      dispatch(setCompany(company));
    }
  }, [company, dispatch]);

  // Get user permissions
  const permissions = userProfile?.roleAndPermission?.permissions || [];

  // Normalize text for comparison
  const normalizeText = (text) => {
    if (!text || typeof text !== "string") return "";
    return text.toLowerCase().replace(/\s+/g, "");
  };

  // Filter links based on user permissions using text property
  const filterLinks = (linksArray) => {
    if (!linksArray) return [];
    if (userProfile?.usertype === "admin" || userProfile?.role === "admin") {
      return linksArray;
    }
    if (!permissions || permissions.length === 0) {
      return linksArray;
    }
    return linksArray.filter((link) => {
      if (!link || !link.text) return false;
      return permissions.some((perm) => {
        if (!perm) return false;
        const normPerm = normalizeText(perm);
        const normText = normalizeText(link.text);
        return (
          normPerm === normText ||
          normText.includes(normPerm) ||
          normPerm.includes(normText) ||
          normPerm === "admin"
        );
      });
    });
  };

  // Get all permitted paths
  const getPermittedPaths = () => {
    if (!permissions || permissions.length === 0) {
      return [];
    }
    const allLinks = Object.values(sections).flat();
    return allLinks
      .filter((link) => {
        if (!link || !link.text) return false;
        return permissions.some(
          (perm) => perm && normalizeText(perm) === normalizeText(link.text),
        );
      })
      .map((link) => link.path);
  };

  // Check if current path is allowed, redirect if not
  useEffect(() => {
    if (isLoading || !userProfile) return;
    const permittedPaths = getPermittedPaths();
    const currentPath = location.pathname;

    // Check if the current path exactly matches or is a sub-path of an allowed route
    const isPathAllowed = permittedPaths.some((path) => {
      if (path === "/") return currentPath === "/";
      const normalizedPath = path.endsWith("/") ? path.slice(0, -1) : path;
      const normalizedCurrent = currentPath.endsWith("/")
        ? currentPath.slice(0, -1)
        : currentPath;
      return (
        normalizedCurrent === normalizedPath ||
        normalizedCurrent.startsWith(`${normalizedPath}/`)
      );
    });

    if (
      !isPathAllowed &&
      currentPath !== "/not-authorized" &&
      currentPath !== "/"
    ) {
      navigate("/not-authorized");
    }
  }, [location.pathname, userProfile, isLoading, navigate]);

  // Set initial open dropdown based on active route
  useEffect(() => {
    if (!userProfile) return;
    const currentPath = location.pathname;
    const activeSection = Object.keys(sections).find((section) => {
      const filteredLinks = filterLinks(sections[section]);
      return filteredLinks.some((link) => link.path === currentPath);
    });
    setOpenDropdown(activeSection || null);

    if (activeSection === "setup") {
      const activeGroup = setupGroups.find((g) => {
        const filteredGroupLinks = filterLinks(g.links);
        return filteredGroupLinks.some((link) => link.path === currentPath);
      });
      if (activeGroup) {
        setOpenSubDropdown(activeGroup.id);
      }
    }
  }, [location.pathname, userProfile]);

  const togglePhoneSidebar = () => {
    setIsOpen(!isOpen);
    dispatch(setPhoneToggle());
  };

  const toggleDropdown = (section) => {
    if (sideBarCollapes === "hide" && window.innerWidth >= 768) {
      dispatch(setSideCollapes("show"));
    }
    setOpenDropdown(openDropdown === section ? null : section);
  };

  const toggleSubDropdown = (subId) => {
    setOpenSubDropdown(openSubDropdown === subId ? null : subId);
  };

  const sectionIcons = {
    main: <HiOutlineHomeModern size={20} />,
    settings: <CiSettings size={20} />,
    products: <AiOutlineProduct size={20} />,
    reports: <TbReportSearch size={20} />,
    setup: <HiOutlineWrenchScrewdriver size={20} />,
    purchase: <CiShop size={20} />,
    inventory: <PiWarehouseLight size={20} />,
    stock: <FaChartLine size={20} />,
    payments: <MdOutlinePayments size={20} />,
    accounts: <MdOutlineAccountBalance size={20} />,
    hr: <TbUserCancel size={20} />,
  };

  const renderProductLinks = () => {
    const allProductPermitted = productGroups.some(
      (group) => filterLinks(group.links).length > 0,
    );
    if (!allProductPermitted) return null;

    const isProductActive = productGroups.some((group) =>
      group.links.some((link) => link.path === location.pathname),
    );

    return (
      <div className="mb-2 relative transition-all duration-300 ease-in-out">
        <button
          onClick={() => toggleDropdown("products")}
          className={`flex items-center w-full p-3 text-gray-800 hover:bg-blue-400 text-sm transition-colors
            ${isProductActive ? "bg-blue-600 text-white" : ""}
            ${sideBarCollapes === "hide" && !isOpen ? "justify-center" : "justify-between"}`}
        >
          <div className="flex items-center">
            <span
              className={sideBarCollapes === "hide" && !isOpen ? "" : "mr-3"}
            >
              {sectionIcons["products"]}
            </span>
            {(sideBarCollapes !== "hide" || isOpen) && (
              <span className="font-medium">Products</span>
            )}
          </div>
          {(sideBarCollapes !== "hide" || isOpen) && (
            <span>
              {openDropdown === "products" ? (
                <IoChevronUp size={16} />
              ) : (
                <IoChevronDown size={16} />
              )}
            </span>
          )}
        </button>

        <div
          className={`transition-all duration-300 ease-in-out
            ${
              sideBarCollapes === "hide" && !isOpen
                ? `absolute left-full top-0 ml-1 bg-white w-60 shadow-lg z-50 max-h-96 overflow-y-auto p-2
                ${
                  openDropdown === "products"
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 translate-x-2 pointer-events-none"
                }`
                : openDropdown === "products"
                  ? "max-h-[30rem] pl-3 opacity-100 overflow-y-auto"
                  : "max-h-0 opacity-0 overflow-hidden"
            }`}
        >
          {productGroups.map((group) => {
            const permittedLinks = filterLinks(group.links);
            if (permittedLinks.length === 0) return null;

            const isGroupActive = permittedLinks.some(
              (link) => link.path === location.pathname,
            );
            const isSubOpen = openSubDropdown === group.id;

            if (permittedLinks.length === 1) {
              const link = permittedLinks[0];
              return (
                <NavLink
                  key={link.id}
                  to={link.path}
                  className={({ isActive }) =>
                    `flex items-center p-2 text-gray-800 hover:bg-blue-50 text-xs font-medium rounded transition-colors my-1
                    ${isActive ? "bg-blue-100 text-blue-700 font-semibold" : ""}`
                  }
                  onClick={() => {
                    setOpenDropdown("products");
                    if (isOpen) setIsOpen(false);
                  }}
                >
                  <span>{link.text}</span>
                </NavLink>
              );
            }

            return (
              <div key={group.id} className="mb-1">
                <button
                  type="button"
                  onClick={() => toggleSubDropdown(group.id)}
                  className={`flex items-center justify-between w-full p-2 text-xs font-semibold rounded transition-colors text-gray-700 hover:bg-gray-100
                    ${isGroupActive ? "text-blue-600 bg-blue-50" : ""}`}
                >
                  <span>{group.title}</span>
                  <span>
                    {isSubOpen ? (
                      <IoChevronUp size={12} />
                    ) : (
                      <IoChevronDown size={12} />
                    )}
                  </span>
                </button>

                <ul
                  className={`pl-3 border-l-2 border-blue-200 ml-1 transition-all duration-200
                    ${isSubOpen ? "max-h-48 opacity-100 my-1 overflow-y-auto" : "max-h-0 opacity-0 overflow-hidden"}`}
                >
                  {permittedLinks.map((link) => (
                    <li key={link.id} className="my-0.5">
                      <NavLink
                        to={link.path}
                        className={({ isActive }) =>
                          `flex items-center p-1.5 text-xs text-gray-700 hover:bg-blue-100 hover:text-blue-700 rounded transition-colors
                          ${isActive ? "bg-blue-600 text-white font-semibold" : ""}`
                        }
                        onClick={() => {
                          setOpenDropdown("products");
                          if (isOpen) setIsOpen(false);
                        }}
                      >
                        <span>{link.text}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderSetupLinks = () => {
    const allSetupPermitted = setupGroups.some(
      (group) => filterLinks(group.links).length > 0,
    );
    if (!allSetupPermitted) return null;

    const isSetupActive = setupLinks.some(
      (link) => link.path === location.pathname,
    );

    return (
      <div className="mb-2 relative transition-all duration-300 ease-in-out">
        <button
          onClick={() => toggleDropdown("setup")}
          className={`flex items-center w-full p-3 text-gray-800 hover:bg-blue-400 text-sm transition-colors
            ${isSetupActive ? "bg-blue-600 text-white" : ""}
            ${sideBarCollapes === "hide" && !isOpen ? "justify-center" : "justify-between"}`}
        >
          <div className="flex items-center">
            <span
              className={sideBarCollapes === "hide" && !isOpen ? "" : "mr-3"}
            >
              {sectionIcons["setup"]}
            </span>
            {(sideBarCollapes !== "hide" || isOpen) && (
              <span className="font-medium">Setup</span>
            )}
          </div>
          {(sideBarCollapes !== "hide" || isOpen) && (
            <span>
              {openDropdown === "setup" ? (
                <IoChevronUp size={16} />
              ) : (
                <IoChevronDown size={16} />
              )}
            </span>
          )}
        </button>

        <div
          className={`transition-all duration-300 ease-in-out
            ${
              sideBarCollapes === "hide" && !isOpen
                ? `absolute left-full top-0 ml-1 bg-white w-60 shadow-lg z-50 max-h-96 overflow-y-auto p-2
                ${
                  openDropdown === "setup"
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 translate-x-2 pointer-events-none"
                }`
                : openDropdown === "setup"
                  ? "max-h-[30rem] pl-3 opacity-100 overflow-y-auto"
                  : "max-h-0 opacity-0 overflow-hidden"
            }`}
        >
          {setupGroups.map((group) => {
            const permittedLinks = filterLinks(group.links);
            if (permittedLinks.length === 0) return null;

            const isGroupActive = permittedLinks.some(
              (link) => link.path === location.pathname,
            );
            const isSubOpen = openSubDropdown === group.id;

            if (permittedLinks.length === 1) {
              const link = permittedLinks[0];
              return (
                <NavLink
                  key={link.id}
                  to={link.path}
                  className={({ isActive }) =>
                    `flex items-center p-2 text-gray-800 hover:bg-blue-50 text-xs font-medium rounded transition-colors my-1
                    ${isActive ? "bg-blue-100 text-blue-700 font-semibold" : ""}`
                  }
                  onClick={() => {
                    setOpenDropdown("setup");
                    if (isOpen) setIsOpen(false);
                  }}
                >
                  <span>{link.text}</span>
                </NavLink>
              );
            }

            return (
              <div key={group.id} className="mb-1">
                <button
                  type="button"
                  onClick={() => toggleSubDropdown(group.id)}
                  className={`flex items-center justify-between w-full p-2 text-xs font-semibold rounded transition-colors text-gray-700 hover:bg-gray-100
                    ${isGroupActive ? "text-blue-600 bg-blue-50" : ""}`}
                >
                  <span>{group.title}</span>
                  <span>
                    {isSubOpen ? (
                      <IoChevronUp size={12} />
                    ) : (
                      <IoChevronDown size={12} />
                    )}
                  </span>
                </button>

                <ul
                  className={`pl-3 border-l-2 border-blue-200 ml-1 transition-all duration-200
                    ${isSubOpen ? "max-h-48 opacity-100 my-1 overflow-y-auto" : "max-h-0 opacity-0 overflow-hidden"}`}
                >
                  {permittedLinks.map((link) => (
                    <li key={link.id} className="my-0.5">
                      <NavLink
                        to={link.path}
                        className={({ isActive }) =>
                          `flex items-center p-1.5 text-xs text-gray-700 hover:bg-blue-100 hover:text-blue-700 rounded transition-colors
                          ${isActive ? "bg-blue-600 text-white font-semibold" : ""}`
                        }
                        onClick={() => {
                          setOpenDropdown("setup");
                          if (isOpen) setIsOpen(false);
                        }}
                      >
                        <span>{link.text}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderLinks = (linksArray, sectionTitle, sectionKey) => {
    // Filter submenu links based on permissions
    const filteredLinks = filterLinks(linksArray);

    // Only render the section if it has permitted links
    if (filteredLinks.length === 0) {
      return null;
    }

    return (
      <div className="mb-2 relative transition-all duration-300 ease-in-out">
        <button
          onClick={() => toggleDropdown(sectionKey)}
          className={`flex items-center w-full p-3 text-gray-800 hover:bg-blue-400 text-sm transition-colors
            ${filteredLinks.some((link) => link.path === location.pathname) ? "bg-blue-600 text-white" : ""}
            ${sideBarCollapes === "hide" && !isOpen ? "justify-center" : "justify-between"}`}
        >
          <div className="flex items-center">
            <span
              className={sideBarCollapes === "hide" && !isOpen ? "" : "mr-3"}
            >
              {sectionIcons[sectionKey]}
            </span>
            {(sideBarCollapes !== "hide" || isOpen) && (
              <span className="font-medium">{sectionTitle}</span>
            )}
          </div>
          {(sideBarCollapes !== "hide" || isOpen) && (
            <span>
              {openDropdown === sectionKey ? (
                <IoChevronUp size={16} />
              ) : (
                <IoChevronDown size={16} />
              )}
            </span>
          )}
        </button>
        <ul
          className={`transition-all duration-300 ease-in-out
            ${
              sideBarCollapes === "hide" && !isOpen
                ? `absolute left-full top-0 ml-1 bg-white w-56 shadow-lg z-50 max-h-80 overflow-y-auto
                ${
                  openDropdown === sectionKey
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 translate-x-2 pointer-events-none"
                }`
                : openDropdown === sectionKey
                  ? "max-h-80 pl-4 opacity-100 overflow-y-auto"
                  : "max-h-0 opacity-0 overflow-hidden"
            }`}
        >
          {filteredLinks.map((link) => (
            <li key={link.id} className="mb-1">
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `flex items-center p-3 text-gray-800 hover:bg-blue-50 text-sm transition-colors
                  ${isActive ? "bg-blue-100 border-l-4 border-blue-500" : ""}`
                }
                onClick={() => {
                  setOpenDropdown(sectionKey);
                  if (isOpen) setIsOpen(false);
                }}
              >
                {link.icon && <span className="mr-3">{link.icon}</span>}
                <span>{link.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const coll = sideBarCollapes === "hide";

  const logo = (
    <div className="logo my-2 flex items-center justify-center">
      <div
        className={`flex  justify-center items-center relative px-4 h-[4rem] border-b-[1px] border-gray-300`}
      >
        <span
          className={`text-5xl ${coll && !isOpen ? "block text-center" : "hidden"} italic text-sky-700`}
        >
          X
        </span>
        <div
          className={`${coll && !isOpen ? "hidden" : "flex"} flex-col gap-0`}
        >
          <img
            src={`${process.env.REACT_APP_BASE_URL}/${company?.logo}`}
            className="w-20"
          />
        </div>
      </div>
    </div>
  );

  const profile = (
    <div className="p-4 border-t border-gray-300">
      <div className="flex items-center">
        <IoPersonCircleOutline
          size={28}
          className={coll && !isOpen ? "" : "mr-2"}
        />
        {(!coll || isOpen) && (
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">
              {userProfile?.username || "Admin User"}
            </p>
            <p className="text-xs text-gray-500 truncate">
              {userProfile?.email || "admin@example.com"}
            </p>
          </div>
        )}
      </div>
    </div>
  );

  const sidebarContent = (
    <div className="h-full flex flex-col">
      {logo}
      <div className="flex-1 overflow-y-auto px-2">
        <nav className="transition-all duration-300 ease-in-out">
          {renderLinks(sections.main, "Main", "main")}
          {renderLinks(sections.settings, "Settings", "settings")}
          {renderProductLinks()}
          {renderSetupLinks()}
          {renderLinks(sections.purchase, "Purchase", "purchase")}
          {renderLinks(sections.inventory, "Inventory", "inventory")}
          {renderLinks(sections.stock, "Stock", "stock")}
          {renderLinks(sections.payments, "Payments", "payments")}
          {renderLinks(sections.accounts, "Accounts", "accounts")}
          {renderLinks(sections.reports, "Reports", "reports")}
          {renderLinks(sections.hr, "HR System", "hr")}
        </nav>
      </div>
      {profile}
    </div>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
      {isOpen ? (
        <button
          className="md:hidden fixed top-4 left-36 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoClose size={20} />
        </button>
      ) : (
        <button
          className="md:hidden fixed top-4 left-5 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoMenu size={20} />
        </button>
      )}

      {/* Desktop Sidebar */}
      <div
        className={`h-screen bg-white text-gray-800 transition-all duration-300 z-40 hidden md:block shadow-lg
          ${sideBarCollapes === "hide" ? "w-20" : "w-56"}`}
      >
        {sidebarContent}
      </div>

      {/* Mobile Drawer */}
      <Drawer
        placement="left"
        closable={false}
        onClose={togglePhoneSidebar}
        open={isOpen}
        width={224}
        styles={{
          body: {
            padding: 0,
            background: "white",
            height: "100%",
            overflow: "hidden",
          },
          header: { display: "none" },
        }}
        className="md:hidden"
      >
        {sidebarContent}
      </Drawer>
    </>
  );
};

export default Sidebar;
